import { z } from 'zod';
import { ContentSchema } from './Content';
import { ScriptPayloadSchema } from './sdk/Triggers';

export const PlayerContentSchema = z.object({
  contentChanged: z.string(),
  content: z.array(ContentSchema).nullable(),
});

export type PlayerContent = z.infer<typeof PlayerContentSchema>;

export const PlayerContentPayloadSchema = z.object({
  contentChanged: z.string(),
  content: z.array(ContentSchema).nullable(),
  script: z.string(),
});

export type ContentPayload = z.infer<typeof PlayerContentPayloadSchema>;

export const PayloadSchema = z.object({
  contentPayload: PlayerContentPayloadSchema,
  scriptPayload: ScriptPayloadSchema,
});

export type Payload = z.infer<typeof PayloadSchema>;
